import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const progressVariants = cva("relative h-4 w-full overflow-hidden", {
 variants: {
  variant: {
   default: "rounded-full bg-secondary",
  },
 },
 defaultVariants: {
  variant: "default",
 },
});

interface ProgressProps
 extends
  React.ComponentProps<typeof ProgressPrimitive.Root>,
  VariantProps<typeof progressVariants> {
 indicatorClassName?: string;
}

function Progress({
  ref,
  className,
  value,
  variant,
  indicatorClassName,
  ...props
}: ProgressProps) {
  return (
    <ProgressPrimitive.Root
      ref={ref}
      value={value}
      className={cn(progressVariants({ variant }), className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          "h-full w-full flex-1 bg-action-fill transition-all",
          indicatorClassName,
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress, progressVariants };
